import React, { useState, useEffect, useRef } from 'react';
import Banners from '../components/Banners.js';
import Footer from '../components/Footer.js'
import { FaArrowRight, FaArrowUpLong, FaBookOpen, FaUser, FaUsers } from "react-icons/fa6";
import { FaStar, faStarSolid, faStarRegular } from 'react-icons/fa';

import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

import '../styles/Home.css';
import { Link } from 'react-router-dom';
import axiosPost from '../helper/axios-helper.js';

export default function Home() {
  const [hoveredItem, setHoveredItem] = useState(0);
  const ref = useRef(null);
  const [hasTriggered, setHasTriggered] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && !hasTriggered) {
          setHasTriggered(true);
        }
      },
      {
        rootMargin: '-100px',
        threshold: 0,
        triggerOnce: true,
      }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, [hasTriggered]);

  const handleMouseEnter = (index) => {
    setHoveredItem(index);
  };

  const handleMouseLeave = () => {
    setHoveredItem(0);
  };

  const [testimonials, setTestimonials] = useState([]);

  const [articles, setArticles] = useState([])

  const [members, setMembers] = useState([
    {
      id: 1,
      name: 'Liberty Caribbean',
      image: '/assets/logosforhomepage/Liberty Caribbean Logo transparent-01.png',
    },
    {
      id: 2,
      name: 'TSTT',
      image: '/assets/logosforhomepage/TSTT logo name above1.jpg',
    },
    {
      id: 3,
      name: 'Digicel',
      image: '/assets/digicel.png',
    },
    {
      id: 4,
      name: 'One Communications',
      image: '/assets/logosforhomepage/One Comm Full Colour.png',
    },
    {
      id: 5,
      name: 'Cable Bahamas',
      image: '/assets/logosforhomepage/CBL ALIV REV stacked.png',
    },
    {
      id: 6,
      name: 'Telesur',
      image: '/assets/telesur.png',
    },
    {
      id: 7,
      name: 'Telem',
      image: '/assets/logosforhomepage/Telem Group Logo Red.png',
    },
    {
      id: 8,
      name: 'SETAR',
      image: '/assets/logosforhomepage/SETAR-Creating-Connections_dark_RGB.png',
    },
  ])

  useEffect(() => {
    fetchTestimonials()
    fetchLatestBlogs()
  }, [])

  const fetchTestimonials = () => {

    axiosPost('testimonials/fetch', {}, {}, (data) => {

      const { success, response } = data;

      if (success) {

        
        setTestimonials(data.data)
          

      } else {
          
      }

    })

  }

  const fetchLatestBlogs = () => {

    axiosPost('blogs/latest', {}, {}, (data) => {

      const { success, response } = data;

      if (success) {
        setArticles(data.data)
      } else {
        console.error('Failed to fetch blogs:', response)
      }

    })

  }
  

  function renderNewsArticles(){

    const formatDate = (timestamp) => {
      const date = new Date(timestamp * 1000);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    };

    const createSlug = (title) => {
      return title
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    };

    const render_articles = articles.map((article, index) => 
      <div
        key={article.id}
        style={{
          position: 'relative',
          height: '100%',
          backgroundImage: `url(${article.image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          filter: hoveredItem === index ? 'none' : 'grayscale(100%)',
          flex: hoveredItem === index ? '1.4' : '1',
          minWidth: '200px',
          transition: 'flex 0.3s ease, filter 0.3s ease',
          overflow: 'hidden',

        }}
        className='news-article'
        onMouseEnter={() => handleMouseEnter(index)}
        onMouseLeave={handleMouseLeave}
        onClick={() => {
          const slug = createSlug(article.title);
          window.location.href = `/article/${slug}`;
        }}
        
      >
          <div
            style={{
              position: 'absolute',
              bottom: hoveredItem === index ? -50 : '-200px',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: '#209E8E',
              color: 'white',
              padding: '10px 15px',
              transition: 'bottom 0.3s ease',
              width: '100%',
              height: '100px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent:'space-between'
            }}
          >
            <div className='home-article-container'>
              <div className='home-article-header'>{article.title}</div>
              <div className='home-article-icon'>
                <FaArrowUpLong size={14} color={'#2c2c2c'} />
              </div>
            </div>
            <div className='home-article-footer'>{formatDate(article.timestamp)}</div>
          </div>
      </div>
    )

    return render_articles;
  }

  function renderMembers() {
    // Duplicate members array for seamless infinite scroll
    const duplicatedMembers = [...members, ...members];

    const render_members = duplicatedMembers.map((member, index) => 
      <div key={index} className='home-member-logo-card'>
        <img 
          src={process.env.PUBLIC_URL + member.image} 
          alt={member.name}
          className='home-member-image'
        />
      </div>
    )

    return render_members;
  }

  function renderTestimonials(){

    const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
        stars.push(
          <FaStar
            key={i}
            color={i <= rating ? '#282C68' : '#2c2c2c'}
          />
        );
      }
      return stars;
    };

    const render_testimonials = testimonials.map((testimonial, index) => 
      <div className='testimonial-card'>
        <div className='testimonial-header-container'>
          <div className='testimonial-header-image' style={{backgroundImage: `url(${testimonial.client.url})`}}></div>
          <div style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
            <div className='testimonial-header-title'>{testimonial.client.name}</div>
            <div className='testimonial-header-subtitle'>{testimonial.client.role}</div>
          </div>
        </div>

        <div className='testimonial-text'>
          {testimonial.testimonial}
        </div>

        <div className='testimonial-rating-container'>
          {renderStars(testimonial.rating)}
        </div>
      </div>
    )

    return render_testimonials;

  }

  const memberSection = () => {

    return (
      <div className='home-members-counter-container' ref={ref}>
        {hasTriggered && 
            <div>
              <div className='members-counter-container'>
                <FaUsers size={32} color={'#282C68'}/>

                <div className='members-count'>
                  <CountUp end={47} duration={2.5} />
                </div>
              </div>
              <div className='members-counter-title'>Full members</div>

              <div className='members-counter-container' style={{marginTop: '20px'}}>
                <FaUsers size={32} color={'#282C68'}/>

                <div className='members-count'>
                  <CountUp end={51} duration={2.5} />
                </div>
              </div>
              <div className='members-counter-title'>Affiliate members</div>
            </div>
        } 
        
      </div>
    )
  }
  

  return (
    <div className='container'>
      <div className='home-landing'>
        <Banners/>
      </div>

      <div className='home-about-wrapper'>
        <div className='home-about-container'>
          <div className='section-header' style={{padding:0, marginBottom: '10px'}}>About CANTO</div>
            <div className='home-about-top'>
              <div className='home-about-card'>
                <div className='home-about-header'>Who are we</div>
                <div className='home-about-subtitle'>
                  At CANTO, we connect the Caribbean through innovation and technology, empowering a unified and sustainable gigabit society. As the leading ICT trade association, we drive collaboration, advocate for policy change, and deliver insights that shape the region's digital future.
                </div>
              </div>
              <div className='home-about-card'>
                <div className='home-about-header'>What we do</div>
                  <div className='home-about-subtitle'>
                    We champion digital growth through advocacy, networking, education, and thought leadership—building a connected future where technology works for everyone.
                  </div>
              </div>
            </div>
            <div className='home-about-card alt'>
              <div className='home-about-header'>Members</div>
              <div className='home-about-subtitle'>
                Join CANTO today and unlock a world of possibilities! Gain exclusive access to cutting-edge resources, industry intelligence, and a powerful network that's shaping the future of ICT in the Caribbean. Don't just watch the digital revolution—be part of it!
           
              </div>
            </div>
          </div>

        <div className='home-emarket-container'>

          <div className='home-options-container'>
            <div className='home-options-title'>Membership</div>

            <Link className='home-option' to={'/membership/categories'}>
              <div className='home-option-text'>Explore Membership</div>
              <div className='home-option-icon'>
                <FaUsers size={12} color='#fff' />
              </div>
            </Link>

            <Link className='home-option' to={'/membership/benefits'}>
              <div className='home-option-text'>Member Benefits</div>
              <div className='home-option-icon'>
                <FaUser size={12} color='#fff' />
              </div>
            </Link>

            <div className='home-option-alt-container'>
              <Link className='home-option alt' to={'/publications/cancion'}>
                <div className='home-option-text'>CANCION Magazine</div>
                <div className='home-option-icon alt'>
                  <FaBookOpen size={12} color='#fff' />
                </div>
              </Link>
            </div>
            

          </div>

          <div className='home-emarket-card'>
            <img src={process.env.PUBLIC_URL + '/assets/emarket.png'} className='home-emarket-image'/>
            <Link to={'/emarket'} className='home-emarket-btn'>
              CANTO E-MARKET <div className='home-emarket-btn-icon'><FaArrowRight size={16} color='#2c2c2c'/></div>
            </Link>
          </div>
        </div>
      </div>

      {/* <div className='home-sponsors-wrapper'>
        <div className='home-sponsors-container'>
          <div className='home-sponsor-card'>
            <img 
              src={process.env.PUBLIC_URL + '/assets/sponsors/Telesur-ad.jpg'} 
              alt='Telesur'
              className='home-sponsor-image'
            />
          </div>
        </div>
      </div> */}

      <div className='home-news-wrapper'>
        <div className='section-header'>Latest News & Updates</div>
        <div className='home-news-container'>
          <div className='home-news'>
            {renderNewsArticles()}
          </div>
          <div className='home-news-info-container'>
            <div className='home-news-info-header-container'>
              <div className='home-news-info-header'>Check out more <br/>articles</div>

              <div className='home-news-info-icon'>
                <FaArrowUpLong size={16} color={'#2c2c2c'} />
              </div>
            </div>

            <Link path={'/news'} className='home-news-info-footer'>View All</Link>
          </div>
        </div>
      </div>
      
      <div className='home-members-wrapper'>
        <div className='section-header'>Our Members</div>
        <div className='home-members-container'>
          { memberSection() }
          <div className='home-members-carousel-wrapper'>
            <div className='home-members-carousel-track'>
              { renderMembers() }
            </div>
          </div>
        </div>
        <div className='home-members-cta'>
          <Link to='/membership/listing' className='home-members-view-all-btn'>
            View all members
            <FaArrowRight size={14} />
          </Link>
        </div>
      </div>

      <div className='home-testimonials-wrapper'>
        <div className='section-header'>Testimonials</div>
        <div className='home-testimonials-container'>
          {renderTestimonials()}
        </div>
      </div>
    </div>
  )
}
